'use client';

import { useSession } from '@shared/auth';
import { Gift2, Reload } from '@shared/icons';
import { useTheme } from 'next-themes';
import { useSearchParams } from 'next/navigation';
import { AreaComponent } from '../../AreaComponent/AreaComponent';
import { FaqSection } from '../../FaqSection/FaqSection';
import { LoginOrSignUp } from '../../LoginOrSignUp/LoginOrSignUp';
import { FreeBetNotification } from '../FreeBetNotification/FreeBetNotification';
import { SportsbookWidget } from '../SportsbookWidget/SportsbookWidget';
import { parseSportsbookSearchParams } from '../utils/sportsbookUrl';

function SportsbookPageContent() {
  const { session } = useSession();
  const isLoggedIn = session.status === 'authenticated';
  const searchParamsClient = useSearchParams();
  const { resolvedTheme } = useTheme();

  const routeParams = parseSportsbookSearchParams(searchParamsClient);
  const currentPage = routeParams.page;
  const isMyBetsPage = currentPage === 'betHistory';
  const isFreeBetsPage = currentPage === 'settings';
  const isDiscoverPage = currentPage === 'overview';
  const playerNr = session?.profile?.nr?.toString() ?? '';

  const shouldShowUnloggedMyBets = !isLoggedIn && (isMyBetsPage || isFreeBetsPage);

  if (shouldShowUnloggedMyBets) {
    return <LoginOrSignUp icon={isMyBetsPage ? Reload : Gift2} namespace={isMyBetsPage ? 'sportsbook.my_bets' : 'sportsbook.free_bets'} />;
  }

  return (
    <>
      {isLoggedIn && playerNr ? <FreeBetNotification playerNr={playerNr} /> : null}
      <div className="pt-4 pb-10 mx-[var(--ll-container-padding)] flex flex-col gap-6">
        {isDiscoverPage ? (
          <div className="overflow-x-hidden">
            <AreaComponent slug="sportsbook" area="TOP" />
          </div>
        ) : null}
        <SportsbookWidget routeParams={routeParams} quickDepositEnabled key={`${currentPage}-${resolvedTheme}`} />
        <FaqSection className="mt-6" namespace="sportsbook.faq" data-track-container="SEO" />
      </div>
    </>
  );
}

export { SportsbookPageContent };
